export default __webpack_public_path__ + "static/media/UserCircle.795b1392.svg";